import React from 'react';
import { ArrowRight, ArrowLeft } from 'lucide-react';
import './Contact.css';

const Contact = ({ t, isVisible, language }) => {
  const emailBody = `Country:
City:
Importer type:
Company name:
Company registration number:
Contact person and role:

Products (up to 10 SKUs):
Active ingredient, strength, dosage form

Expected volume per product:
Cold chain required (yes or no):
Preferred currency (EUR or USD):
Target timeline:`;

  const mailtoLink = `mailto:sami.chalhoub@chalhoubtrade.de?subject=${encodeURIComponent('Feasibility request, pharmaceutical sourcing')}&body=${encodeURIComponent(emailBody)}`;

  const ArrowIcon = language === 'ar' ? ArrowLeft : ArrowRight;
  const isArabic = language === 'ar';

  return (
    <section id="contact" className={`contact ${isVisible ? 'visible' : ''}`}>
      <div className="contact-container">
        <div className="contact-header">
          <h2 className="contact-title">{t.contact.title}</h2>
          <p className="contact-subtitle">{t.contact.subtitle}</p>
        </div>

        <div className="contact-content">
          <div className="contact-checklist">
            <ul className="checklist-items">
              {t.contact.checklistItems.map((item, index) => (
                <li key={index} className="checklist-item">
                  {isArabic ? (
                    <>
                      <span>{item}</span>
                      <ArrowLeft size={16} className="checklist-arrow" />
                    </>
                  ) : (
                    <>
                      <ArrowRight size={16} className="checklist-arrow" />
                      <span>{item}</span>
                    </>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <a 
            href={mailtoLink}
            className="feasibility-button"
            data-testid="feasibility-request-btn"
          >
            {t.contact.feasibilityLink}
            <ArrowIcon size={20} />
          </a>

          <p className="language-disclaimer">{t.contact.languageDisclaimer}</p>
        </div>
      </div>
    </section>
  );
};

export default Contact;